import React, { useContext, useEffect } from "react";

import {
  Box,
  Card,
  Column,
  Columns,
  Divider,
  Heading,
  Radio,
  RadioGroup,
  Stack,
} from "@origin-digital/ods-core";
import { Field, Formik, FormikProps, yupToFormErrors } from "formik";
import {
  ClaimDialogValues,
  claimFormInitialValues,
  ClaimFormValues,
  HomeUserClaimFormValues,
} from "./types";
import { AccountPayer, ErrorTypeEnum } from "../types";
import { IFormFunctionProps } from "../FormAccordionContainer";
import { homeUserClaimFormValidationSchema } from "./validations";
import HomeUserClaimsAccountBlock from "./HomeUserClaimsAccountBlock";
import { accountBlockInitialValues } from "../FormComponents/Validations";
import FormContext from "../../../context/FormContext";

interface IClaimFormContentProps extends IFormFunctionProps {
  dialogValues: ClaimDialogValues;
  homeUser: boolean;
}

const HomeUserClaimFormContent = (props: IClaimFormContentProps) => {
  const { dialogValues } = props;
  const { setDisplayingAlertBanner } = useContext(FormContext);
  const { setRequestDetailsLoaded } = useContext(FormContext);

  useEffect(() => {
    setRequestDetailsLoaded(true);
  }, []);
  return (
    <>
      <Formik<HomeUserClaimFormValues>
        initialValues={{ ...claimFormInitialValues, ...dialogValues }}
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={homeUserClaimFormValidationSchema}
        validate={(values) => {
          let allErrors: any = {};
          try {
            homeUserClaimFormValidationSchema.validateSync(values, {
              abortEarly: false,
            });
            setDisplayingAlertBanner(null);
          } catch (e) {
            allErrors = { ...yupToFormErrors(e) };
            setDisplayingAlertBanner(ErrorTypeEnum.OCP_FIELD_VALIDATION);
          }
          return allErrors;
        }}
        onSubmit={() => {}}
      >
        {({ values, setFieldValue }) => (
          <Card padding="small" outline borderRadius="medium">
            {/* Form + Button container */}
            <Stack
              space={{
                xs: "xxlarge",
                md: "xxxlarge",
              }}
            >
              {/* Form container */}
              <Stack
                space={{
                  xs: "xlarge",
                  md: "xxlarge",
                }}
              >
                <Heading variant="h3">Claim request</Heading>

                {/* Responsibility for account */}
                <Columns
                  collapseBelow="md"
                  space={{
                    xs: "none",
                    md: "xlarge",
                  }}
                  alignY="stretch"
                >
                  {/* Fields */}
                  <Column width="2/3">
                    <Stack
                      space={{
                        xs: "xlarge",
                        md: "xxlarge",
                      }}
                    >
                      {/* Who's responsible? */}
                      <Field id="account-payer" name="electricityAccountPayer">
                        {({
                          field,
                          meta,
                        }: {
                          field: FormikProps<ClaimFormValues>;
                          meta: any;
                        }) => (
                          <RadioGroup
                            {...field}
                            id="electricityAccountPayer"
                            name="electricityAccountPayer"
                            label="Who's responsible for the electricity account?"
                            error={meta.error}
                            helperText={meta.error}
                            value={values.electricityAccountPayer}
                            onChange={(e) => {
                              Object.keys(accountBlockInitialValues).forEach(
                                (k) => {
                                  setFieldValue(
                                    `${k}`,
                                    accountBlockInitialValues[
                                      k as keyof typeof accountBlockInitialValues
                                    ]
                                  );
                                }
                              );
                              setFieldValue!(
                                "electricityAccountPayer",
                                e.target.value
                              );
                            }}
                          >
                            <Box
                              display="flex"
                              flexWrap="wrap"
                              flexDirection={{
                                xs: "column",
                                sm: "column",
                              }}
                            >
                              <Box marginRight="medium">
                                <Radio
                                  id="my-company"
                                  label={"Me/My company"}
                                  value={AccountPayer.COMPANY}
                                />
                              </Box>
                              <Radio
                                id="customer"
                                label="Customer"
                                value={AccountPayer.SOMEONE_ELSE}
                              />
                            </Box>
                          </RadioGroup>
                        )}
                      </Field>
                      {/* End Who's responsible? */}

                      {/* Site Supervisor */}
                      {/* <HomeUserClaimsSiteSupervisor /> */}
                      {/* <ContactField
                        contactType="SUPERVISOR"
                        name="siteSupervisor"
                        label="Site supervisor"
                      /> */}
                      {/* End Site Supervisor */}
                    </Stack>
                  </Column>
                  {/* Fields */}
                  {/* HelperText */}
                  <Column width="1/3" />
                  {/* End HelperText */}
                </Columns>
                {/* End Responsibility for account */}

                {/* Account section */}

                <Divider />
                <HomeUserClaimsAccountBlock
                  referenceNumber={dialogValues.requestId}
                  accountPayer={values.electricityAccountPayer}
                  msaNumber={dialogValues.requestingCompany?.msaNumber}
                  projectId={dialogValues.projectId}
                  siteSupervisorId={values.siteSupervisor}
                  dbApplicationId={
                    dialogValues.currentClaimTarget?.claimableJourney
                      ?.distributor_application_id
                  }
                  journeyId={
                    dialogValues.currentClaimTarget?.claimableJourney
                      ?.journey_id
                  }
                />
                {/* End Account section */}
              </Stack>
              {/* End Form container */}
            </Stack>
            {/* End Form + Button container */}
          </Card>
        )}
      </Formik>
    </>
  );
};

export default HomeUserClaimFormContent;
